import { XAxis, YAxis, CartesianGrid, Line, LineChart, Label, ScatterChart, Scatter, AreaChart, Area} from "recharts";
import "bootstrap/dist/css/bootstrap.min.css";
import moment from "moment";
import { addDays } from "date-fns";

// The rendering stage component contains the actual visualizations. It has access to several data through functions passed to it from the main page.
export default function RenderingStage({ selectedDay, dataSetsDomain, strokeWidth, heatData, domain, chartType }) {
  
  function addDay() {
    let date = new Date(selectedDay);
    date.setDate(date.getDate() + 1);
    return date;
  }
  
  let col1 = "#AA5656";
  let col2 = "#698269";
  // Create a chart component to display the selected data
  function createScatterChart() {

    const minMillis = new Date(selectedDay).getTime();
    const maxMillis = new Date(addDays(selectedDay, 1)).getTime();

    const data = [];
    let millis;
    for (let i = 0; i < heatData.length; i++) {
      if(heatData[i].length > 0) {
        for (let j = 0; j < heatData[i].length; j++) {
          millis = new Date(heatData[i][j].datetime).getTime();
          if (minMillis <= millis && millis <= maxMillis) {
            if(i === 0)
              data.push({"datetime": millis, "temp-0": heatData[i][j].temp});
            else
              data.push({"datetime": millis, "temp-1": heatData[i][j].temp});
          } else if (millis > maxMillis) {
            break;
          }
        }
      }
    }
    
    return (
      <div style={{ margin: "auto" }}>
        <ScatterChart height={325} width={700} data={data} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
          <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
          <XAxis
            dataKey="datetime"
            domain={[selectedDay,addDay()]}
            name="Time"
            type="number"
            tickFormatter = {(unixTime) => moment(unixTime).format("DD/MM/yy HH:mm")}
            tick={{fontSize: 12}}
            minTickGap={-200}
            height={80}
          >
            <Label value={"Date and time"} offset={23} position="insideBottom" />
          </XAxis>
          <YAxis name="Value" width={80} domain={["auto","auto"]} tick={{fontSize: 12}}>  
            <Label angle={270} offset={30} value={"Temperature (℃)"} position="insideBottomLeft" />
          </YAxis>
          <Scatter
            dataKey="temp-0"
            stroke={col1}
            fill={col1}
            dot={false}
            strokeWidth={strokeWidth}
          />
          <Scatter
            dataKey="temp-1"
            stroke={col2}
            fill={col2}
            dot={false}
            strokeWidth={strokeWidth}
          />
        </ScatterChart>
      </div>
    )
  }
  
  // Create a chart component to display the selected data
  function createLineChart() {
    const minMillis = dataSetsDomain[0] === "auto" ? 0 : dataSetsDomain[0];
    const maxMillis = dataSetsDomain[1] === "auto" ? Number.MAX_VALUE : dataSetsDomain[1];
    const minMillisAdjusted = minMillis + (maxMillis - minMillis)*domain[0]/100;
    const maxMillisAdjusted = maxMillis - (maxMillis - minMillis)*(1 - domain[1]/100);

    const data = [];
    let millis;
    for (let i = 0; i < heatData.length; i++) {
      if(heatData[i].length > 0) {
        for (let j = 0; j < heatData[i].length; j++) {
          millis = new Date(heatData[i][j].datetime).getTime();
          if (minMillisAdjusted <= millis && millis <= maxMillisAdjusted) {
            if (i === 0)
              data.push({"datetime": millis, "temp-0": heatData[i][j].temp});
            else
              data.push({"datetime": millis, "temp-1": heatData[i][j].temp});
          } else if (millis > maxMillisAdjusted) {
            break;
          }
        }
      }
    }
    
    return (
      <div style={{ margin: "auto" }}>
        {/* <ResponsiveContainer height='100%' width='100%'> */}
        <LineChart height={325} width={700} data={data} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
          <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
          <XAxis
            dataKey="datetime"
            domain={dataSetsDomain.map(millis => new Date(millis))}
            name="Time"
            type="number"
            tickFormatter = {(unixTime) => moment(unixTime).format("DD/MM/yy HH:mm")}
            tick={{fontSize: 12}}
            minTickGap={-200}
            height={80}
          >
            <Label value={"Date and time"} offset={23} position="insideBottom" />
          </XAxis>
          <YAxis name="Value" width={80} domain={["auto","auto"]} tick={{fontSize: 12}}>  
            <Label angle={270} offset={30} value={"Temperature (℃)"} position="insideBottomLeft" />
          </YAxis>
          <Line
            dataKey="temp-0"
            stroke={col1}
            dot={false}
            strokeWidth={strokeWidth}
          />
          <Line
            dataKey="temp-1"
            stroke={col2}
            dot={false}
            strokeWidth={strokeWidth}
          />
        </LineChart>
        {/* </ResponsiveContainer> */}
      </div>
    )
  }

   // Create a chart component to display the selected data
   function createSpanLineChart() {
    const minMillis = dataSetsDomain[0] === "auto" ? 0 : dataSetsDomain[0];
    const maxMillis = dataSetsDomain[1] === "auto" ? Number.MAX_VALUE : dataSetsDomain[1];
    const minMillisAdjusted = minMillis + (maxMillis - minMillis)*domain[0]/100;
    const maxMillisAdjusted = maxMillis - (maxMillis - minMillis)*(1 - domain[1]/100);

    const data = [];
    let millis;
    for (let i = 0; i < heatData.length; i++) {
      if(heatData[i].length > 0) {
        let lastDay = Math.round(new Date(heatData[i][0].datetime).getDay());
        let minTemp = 100
        let maxTemp = -100
        for (let j = 0; j < heatData[i].length; j++) {
          millis = new Date(heatData[i][j].datetime).getTime();
          let days = new Date(heatData[i][j].datetime).getDay();
          // Push the data when the day changes or it's the last datapoint 
          if ((lastDay !== days || j === heatData[i].length-1) && minTemp !== 100 && maxTemp !== -100){
            if (minMillisAdjusted <= millis && millis <= maxMillisAdjusted) {
              if (i === 0){
                data.push({"datetime": millis, "temp-0": [minTemp, maxTemp]});
              } else {
                data.push({"datetime": millis, "temp-1": [minTemp, maxTemp]});
              }
            } else if (millis > maxMillisAdjusted) {
              break;
            }
            minTemp = 100;
            maxTemp = -100;
            lastDay = days;
          }
          else{
            // calculate min and max for the day
            if (heatData[i][j].temp > maxTemp){
              maxTemp = heatData[i][j].temp;
            }
            if (heatData[i][j].temp < minTemp){
              minTemp = heatData[i][j].temp;
            }
          }
        }
      }
    }
    
    return (
      <div style={{ margin: "auto" }}>
        <AreaChart height={325} width={700} data={data} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
          <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
          <XAxis
            dataKey="datetime"
            domain={dataSetsDomain.map(millis => new Date(millis))}
            name="Time"
            type="number"
            tickFormatter = {(unixTime) => moment(unixTime).format("DD/MM/yy HH:mm")}
            tick={{fontSize: 12}}
            minTickGap={-200}
            height={80}
          >
            <Label value={"Date and time"} offset={23} position="insideBottom" />
          </XAxis>
          <YAxis name="Value" width={80} domain={["auto","auto"]} tick={{fontSize: 12}}>  
            <Label angle={270} offset={30} value={"Temperature (℃)"} position="insideBottomLeft" />
          </YAxis>
          <Area
            dataKey="temp-0"
            stroke={col1}
            fill={col1}
            dot={false}
            strokeWidth={strokeWidth}
          />
          <Area
            dataKey="temp-1"
            stroke={col2}
            fill={col2}
            dot={false}
            strokeWidth={strokeWidth}
          />
        </AreaChart>
      </div>
    )
  }

  function createChart() {
    switch(chartType) {
      case "Line": 
        return createLineChart();
      case "Scatter":
        return createScatterChart();
      case "Span":
        return createSpanLineChart();
      default:
        return createLineChart(); 
    }
  }

  // Return the complete rendering stage component
  return (
    <div style={{ display: "flex", justifyContent: "center", height: "100%" }}>
      {createChart()}
    </div>
  );
};